import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import Loading from '../../Shared/Loading/Loading';

const RequireAdmin = ({ children }) => {
    const userState = useSelector(state => state.user);
    const location = useLocation();

    // Check if user state is loading
    if (userState.fetchStatus === 'loading') {
        return <Loading></Loading>;
    }

    // Check if user is logged in
    if (!userState.data) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check if user has admin role
    if (userState.data.role !== 'admin') {
        return (
            <div className='text-center mt-5'>
                <h3 className='text-red-600 text-2xl font-bold'>Access Denied</h3>
                <h5 className='text-gray-600 mt-3'>You need administrator privileges to access this page.</h5>
                <button
                    className='mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700'
                    onClick={() => window.history.back()}
                >
                    Go Back
                </button>
            </div>
        );
    }

    return children;
};

export default RequireAdmin;
